

const DEFAULTOPTIONS = {
    title: {
        optionName: 'Title',
        optionValue: 'title',
        customizeProperties: {
            image: {
                propertyName: "Image",
                propertyType: "text",
                propertyValue: ''
            },
            text: {
                propertyName: "Text",
                propertyType: "text",
                propertyMaxLength: "150",
                propertyValue:
                    "Take extra off your purchase by using these coupons exclusively tailored for you.",
            },
            textColor: {
                propertyName: "Text-Color",
                propertyType: "color",
                propertyValue: "#000000",
            },
            fontStyle: {
                propertyName: "Font-Style",
                propertyType: "select",
                propertyValue: "normal",
                propertyOptions: [
                    {
                        optionName: "Normal",
                        optionValue: "normal",
                    },
                    {
                        optionName: "Italic",
                        optionValue: "italic",
                    },
                ],
            },
            fontFamily: {
                propertyName: 'Font-Family',
                propertyType: 'select',
                propertyValue: 'sans-serif',
                propertyOptions: [
                    {
                        optionName: "Serif",
                        optionValue: "serif",
                    },
                    {
                        optionName: "Cursive",
                        optionValue: "cursive",
                    },
                    {
                        optionName: "Sans-Serif",
                        optionValue: "sans-serif",
                    },
                ],
            },
        }
    },
    offer1: {
        optionName: 'Offer 1',
        optionValue: 'offer1',
        customizeProperties: {
            image: {
                propertyName: 'Product Image',
                propertyType: 'text',
                propertyValue: '',
            },
            offerName: {
                propertyName: "Offer Name",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "Offer name",
            },
            offer: {
                propertyName: "Offer",
                propertyType: "text",
                propertyMaxLength: "17",
                propertyValue:
                    "FREE SHIPPING",
            },
            couponCode: {
                propertyName: "Coupon",
                propertyType: "text",
                propertyMaxLength: "15",
                propertyValue:
                    "COUPONCODE",
            }
        }
    },
    offer2: {
        optionName: 'Offer 2',
        optionValue: 'offer2',
        customizeProperties: {
            image: {
                propertyName: 'Product Image',
                propertyType: 'text',
                propertyValue: '',
            },
            offerName: {
                propertyName: "Offer Name",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "Offer name",
            },
            offer: {
                propertyName: "Offer",
                propertyType: "text",
                propertyMaxLength: "17",
                propertyValue:
                    "25% OFF",
            },
            couponCode: {
                propertyName: "Coupon",
                propertyType: "text",
                propertyMaxLength: "15",
                propertyValue:
                    "COUPONCODE",
            }
        }
    },
    product1: {
        optionName: 'Product 1',
        optionValue: 'product1',
        customizeProperties: {
            image: {
                propertyName: 'Product Image',
                propertyType: 'text',
                propertyValue: '',
            },
            productName: {
                propertyName: "Product Name",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "Product Name",
            },
            quantity: {
                propertyName: "Quantity",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "1",
            },
            initialPrice: {
                propertyName: "Initial Price",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "80",
            },
            discountPrice: {
                propertyName: "Discount Price",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "72",
            },
            offer: {
                propertyName: 'Offer',
                propertyType: 'text',
                propertyValue: '10% OFF with coupon code:'
            },
            couponCode: {
                propertyName: "Coupon",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "COUPON CODE",
            }
        }
    },
    product2: {
        optionName: 'Product 2',
        optionValue: 'product2',
        customizeProperties: {
            image: {
                propertyName: 'Product Image',
                propertyType: 'text',
                propertyValue: '',
            },
            productName: {
                propertyName: "Product Name",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "Product Name",
            },
            quantity: {
                propertyName: "Quantity",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "1",
            },
            initialPrice: {
                propertyName: "Initial Price",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "80",
            },
            discountPrice: {
                propertyName: "Discount Price",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "72",
            },
            offer: {
                propertyName: 'Offer',
                propertyType: 'text',
                propertyValue: '10% OFF with coupon code:'
            },
            couponCode: {
                propertyName: "Coupon",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "COUPON CODE",
            }
        }
    },
    product3: {
        optionName: 'Product 3',
        optionValue: 'product3',
        customizeProperties: {
            image: {
                propertyName: 'Product Image',
                propertyType: 'text',
                propertyValue: '',
            },
            productName: {
                propertyName: "Product Name",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "Product Name",
            },
            quantity: {
                propertyName: "Quantity",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "1",
            },
            initialPrice: {
                propertyName: "Initial Price",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "80",
            },
            discountPrice: {
                propertyName: "Discount Price",
                propertyType: "text",
                propertyMaxLength: "12",
                propertyValue:
                    "72",
            },
            offer: {
                propertyName: 'Offer',
                propertyType: 'text',
                propertyValue: '10% OFF with coupon code:'
            },
            couponCode: {
                propertyName: "Coupon",
                propertyType: "text",
                propertyMaxLength: "25",
                propertyValue:
                    "COUPON CODE",
            }
        }
    },
    discountCode: {
        optionName: 'Discount Code',
        optionValue: 'discountCode',
        customizeProperties: {
            text: {
                propertyName: "Text",
                propertyType: "text",
                propertyMaxLength: "14",
                propertyValue:
                    "DISCOUNT CODE",
            },
            textColor: {
                propertyName: "Text-Color",
                propertyType: "color",
                propertyValue: "#000000",
            },
            fontStyle: {
                propertyName: "Font-Style",
                propertyType: "select",
                propertyValue: "normal",
                propertyOptions: [
                    {
                        optionName: "Normal",
                        optionValue: "normal",
                    },
                    {
                        optionName: "Italic",
                        optionValue: "italic",
                    },
                ],
            },
            fontFamily: {
                propertyName: 'Font-Family',
                propertyType: 'select',
                propertyValue: 'sans-serif',
                propertyOptions: [
                    {
                        optionName: "Serif",
                        optionValue: "serif",
                    },
                    {
                        optionName: "Cursive",
                        optionValue: "cursive",
                    },
                    {
                        optionName: "Sans-Serif",
                        optionValue: "sans-serif",
                    },
                ],
            },
            borderColor: {
                propertyName: 'Border-Color',
                propertyType: 'color',
                propertyValue: '#000000'
            }
        }
    },
    footer: {
        optionName: 'Footer',
        optionValue: 'footer',
        customizeProperties: {
            image: {
                propertyName: 'Image',
                propertyType: 'text',
                propertyValue: ''
            },
            copyRight: {
                propertyName: 'Copy Right',
                propertyType: 'text',
                propertyValue: '2023 CausalFunnel. All rights reserved.'
            },
            backgroundColor: {
                propertyName: 'Background-Color',
                propertyType: 'color',
                propertyValue: '#bbefff'
            }
        }
    }
}



export const TEMPLATEOPTIONS = {
    defaultTemplate: DEFAULTOPTIONS,
}